<template>
    <div class="observer"/>
</template>

<script>
export default {
    name: 'InfiniteScroller',
    props: ['options'],
    data() {
        return {
            observer: null,
        }
    },
    methods:{
        scrollTrigger() {
            const options = this.options || {};

            this.observer = new IntersectionObserver(([entry]) => {
                if (entry && entry.isIntersecting) {
                    /* 
                    * this emit calls the items api to update commit-itemsOnDisplay quantity
                    * using dispatch-fullfilSearchAction & dispatch-categoryItemsAction
                    */
                    this.$emit("emitLoadMoreContent");
                }
            }, options);

            this.observer.observe(this.$el);
        },
    },
    mounted(){
        this.scrollTrigger()
    }
}
</script>